import React from 'react'
import { Routes, Route } from "react-router-dom-v5-compat"
import ItemsList from './ItemsList'
import ProductDetails from './ProductDetails'
import ProductEdit from './ProductAddModal/ProductEdit';

const Products = () => {
    return (
        <Routes>
            <Route path="products/edit/:id" element={<ProductEdit />} />
            <Route path="products/edit" element={<ProductEdit />} />
            <Route path="products/:id" element={<ProductDetails />} />
            <Route path="products" element={<ItemsList />} />
        </Routes>
    )
}

export default Products
